import { getAdminEnrollmentInitData } from "./enrollmentInit";

export const pages = {
	getAdminEnrollmentInitData
};
